import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
} from "@chakra-ui/react";

const CommonModal = ({
  isOpen,
  onClose,
  title = "",
  children,
  footer,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered motionPreset="scale">
      <ModalOverlay bg="blackAlpha.400" backdropFilter="blur(2px)" />
      <ModalContent borderRadius="xl" mx={4}>
        <ModalHeader fontSize="lg" fontWeight="semibold">
          {title}
        </ModalHeader>
        <ModalCloseButton borderRadius="md" />
        <ModalBody fontSize="sm" color="gray.600">
          {children}
        </ModalBody>
        {footer && <ModalFooter>{footer}</ModalFooter>}
      </ModalContent>
    </Modal>
  );
};

export default CommonModal;
